
import gql from 'graphql-tag';
import QuickGuideWrapper from '../../../components/quick-guide/QuickGuideWrapper.vue';
import medicalPlanScenariosQuery from '~/apollo/queries/product/medicalPlanScenarios';
import insuranceCompaniesQuery from '~/apollo/queries/product/insuranceCompanies';
import medicalRoomQuery from '~/apollo/queries/product/medicalRoom';
import medicalGeoRegionQuery from '~/apollo/queries/product/medicalGeoRegion';
import medicalVhisTypeQuery from '~/apollo/queries/product/medicalVhisType';
import productPromotionFragment from '~/apollo/fragments/productPromotionFragment';
import medicalTooltips from '~/apollo/queries/product/tooltips/medicalTooltips';
import commonProductMixins from '~/mixins/commonProductMixins.js';
import productPromotionMixins from '~/mixins/productPromotionMixins.js';
import insuranceGuideQuery from '@/apollo/queries/home/insuranceguide'
import productShortcutMixins from "~/mixins/productShortcutMixins.js";
import apolloQuickGuideMixins from '~/mixins/apolloQuickGuideMixins';
import productInsuranceNameMixins from '~/mixins/productInsuranceNameMixins';

export default {
  name: 'ProductsMedicalListingPage',
  mixins: [commonProductMixins, productPromotionMixins, productShortcutMixins, apolloQuickGuideMixins, productInsuranceNameMixins],

  apollo: {
    $loadingKey: 'loading',
    medicalPlanScenarios: {
      query: gql`
        ${medicalPlanScenariosQuery}
        ${productPromotionFragment}
      `,
      prefetch: true,
      variables() {
        let tmpComp;
        tmpComp = undefined;

        let tmpGeoRegion;
        tmpGeoRegion = undefined;

        let tmpVHISType;
        tmpVHISType = undefined;

        let tmpLocale;
        tmpLocale = undefined;

        if (this.filter.insCompValue?.length) {
          tmpComp = this.filter.insCompValue.map((x) => x.value);
        }

        if (this.filter.geoRegionValue?.length) {
          tmpGeoRegion = this.filter.geoRegionValue.map((x) => x.value);
        }

        // if (parseInt(this.filter.geoRegionValue?.value) !== -1) {
        //   tmpGeoRegion = this.filter.geoRegionValue?.value;
        // }

        if (parseInt(this.filter.vhisTypeValue?.value) !== -1) {
          tmpVHISType = parseInt(this.filter.vhisTypeValue?.value);
        }

        if (this.currentLocale) {
          tmpLocale = this.currentLocale;
        }

        const returnObj = {
          insCompCode: tmpComp,
          gender: parseInt(this.filter.genderValue?.value),
          age: parseInt(this.filter.ageValue?.value),
          endAge: parseInt(this.filter.ageValue?.value) + 9,
          room_type: parseInt(this.filter.roomValue?.value),
          deductible_from: parseInt(this.filter.deductibleValue?.value[0]),
          deductible_to:
            this.filter.deductibleValue?.value[1] === 150000
              ? undefined
              : parseInt(this.filter.deductibleValue?.value[1]),
          // average_premium_from: parseFloat(this.filter.avgAnnualPremiumValue?.value[0]),
          // average_premium_to:
          //   this.filter.avgAnnualPremiumValue?.value[1] === 50000
          //     ? undefined
          //     : parseFloat(this.filter.avgAnnualPremiumValue?.value[1]),
          // first_premium_from: parseFloat(this.filter.firstPremiumValue?.value[0]),
          // first_premium_to:
          //   this.filter.firstPremiumValue?.value[1] === 50000
          //     ? undefined
          //     : parseFloat(this.filter.firstPremiumValue?.value[1]),
          geo_region: tmpGeoRegion,
          vhis_type: tmpVHISType,
          locale: tmpLocale,
        };

        return returnObj;
      },
    },
    insuranceCompanies: {
      query: insuranceCompaniesQuery,
      prefetch: true,
      variables() {
        return {
          show_medical: true,
        };
      },
      update(data) {
        return data.insuranceCompanies.data.map((item) => {
          const translations = item.attributes.insurance_company_translations.data;
          // console.debug(translations);
          const filteredTranslations = this.getFilteredTranslations(translations);
          return {
            value: item.attributes.code,
            text:
              filteredTranslations[0].attributes.name +
              ' | ' +
              filteredTranslations[1].attributes.name,
          };
        });
      },
    },
    medicalRooms: {
      query: medicalRoomQuery,
      prefetch: true,
      variables() {
        let tmpLocale;
        tmpLocale = undefined;
        if (this.currentLocale) {
          tmpLocale = this.currentLocale;
        }

        return {
          locale: tmpLocale,
        };
      },
    },
    medicalGeoRegions: {
      query: medicalGeoRegionQuery,
      prefetch: true,
      variables() {
        let tmpLocale;
        tmpLocale = undefined;
        if (this.currentLocale) {
          tmpLocale = this.currentLocale;
        }

        return {
          locale: tmpLocale,
        };
      },
    },
    medicalVhisTypes: {
      query: medicalVhisTypeQuery,
      prefetch: true,
      variables() {
        let tmpLocale;
        tmpLocale = undefined;
        if (this.currentLocale) {
          tmpLocale = this.currentLocale;
        }

        return {
          locale: tmpLocale,
        };
      },
    },
    medicalTooltips: {
      query: medicalTooltips,
      prefetch: true,
      variables() {
        return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
      },
      update(data) {
        return this.$normalizeStrapi(data.infoTooltip.data);
      },
    },
  },
  data() {
    return {
      loading: 0,
      currentLocale: this.$normalizeLocale(this.$i18n.locale),
      filterModalOpen: false,
      filter: {
        insCompValue: [],
        selectionSelected: this.$route.query.applyOnlineInsurer === 'true',
        genderValue: {
          value: this.$route.query.gender ? this.$route.query.gender : '1',
          text: this.$t('products.male'),
        },
        genderOptions: [
          { value: '1', text: this.$t('products.male') },
          { value: '2', text: this.$t('products.female') },
        ],

        ageValue: { value: this.$route.query.age ? this.$route.query.age : '30', text: '30' },
        ageOptions: Array(81)
          .fill(0)
          .map((_, i) => ({
            value: i.toString(),
            text: i.toString(),
          })),

        roomValue: {
          value: this.$route.query.roomtype ? this.$route.query.roomtype : '65',
          text: this.$t('products.medical.md_roomTypeDefaultText'),
        },

        geoRegionValue: [{value: "86", text: this.$t('products.medical.md_default_geo_asia')}, {value: "87", text: this.$t('products.medical.md_default_geo_global_ex_us')}, {value: "88", text: this.$t('products.medical.md_default_geo_greater_china')}],
        // geoRegionValue: {
        //   value: this.$route.query.geo ? this.$route.query.geo : '-1',
        //   text: this.$t('products.medical.md_geoRegionDefaultText'),
        // },

        deductibleValue: {
          value: [
            this.$route.query.deductiblefrom ? parseInt(this.$route.query.deductiblefrom) : 15000,
            this.$route.query.deductibleto ? parseInt(this.$route.query.deductibleto) : 23000,
          ],
          text: this.$t('products.medical.md_deductible'),
        },
        deductibleOptions: [
          {
            value: [
              this.$route.query.deductiblefrom ? parseInt(this.$route.query.deductiblefrom) : 0,
              this.$route.query.deductibleto ? parseInt(this.$route.query.deductibleto) : 150000,
            ],
            text: this.$t('products.medical.md_deductible'),
          },
        ],
        deductibleSliderRange: [0, 150000],
        deductibleSliderStep: 1000,

        avgAnnualPremiumValue: {
          value: [
            this.$route.query.avgpremfrom ? parseInt(this.$route.query.avgpremfrom) : 0,
            this.$route.query.avgpremto ? parseInt(this.$route.query.avgpremto) : 50000,
          ],
          text: this.$t('products.medical.md_averageAnnualPremium'),
        },
        avgAnnualPremiumOptions: [
          {
            value: [
              this.$route.query.avgpremfrom ? parseInt(this.$route.query.avgpremfrom) : 0,
              this.$route.query.avgpremto ? parseInt(this.$route.query.avgpremto) : 50000,
            ],
            text: this.$t('products.medical.md_averageAnnualPremium'),
          },
        ],
        avgAnnualPremiumSliderRange: [0, 50000],
        avgAnnualPremiumSliderStep: 1000,

        firstPremiumValue: {
          value: [
            this.$route.query.firstpremfrom ? parseInt(this.$route.query.firstpremfrom) : 0,
            this.$route.query.firstpremto ? parseInt(this.$route.query.firstpremto) : 50000,
          ],
          text: this.$t('products.medical.md_firstYearPremium'),
        },
        firstPremiumOptions: [
          {
            value: [
              this.$route.query.firstpremfrom ? parseInt(this.$route.query.firstpremfrom) : 0,
              this.$route.query.firstpremto ? parseInt(this.$route.query.firstpremto) : 50000,
            ],
            text: this.$t('products.medical.md_firstYearPremium'),
          },
        ],
        firstPremiumSliderRange: [0, 50000],
        firstPremiumSliderStep: 1000,


        vhisTypeValue: { value: this.$route.query.vhistype ? this.$route.query.vhistype : '-1', text: '' },
      },
      perPage: 15,
      currentPage: 1,
      medicalPlanScenarios: null,
      insuranceCompanies: [],

      sortingData: {
        title: this.$t('products.sort'),
        sortValue: { value: this.$route.query.sort ? this.$route.query.sort : 'five_star', text: '' },
        sortingOptions: [
          { value: 'five_star', text: this.$t('products.medical.md_5StarRatings') },
          { value: 'overall_score', text: this.$t('products.medical.md_overall_score') },
          { value: 'medical_coverage_score', text: this.$t('products.medical.md_medicalCoverageScore') },
          { value: 'special_feature_score', text: this.$t('products.medical.md_special_feature_score') },
          { value: 'average_premium', text: this.$t('products.medical.md_10_yearAvgPremiumLowtoHigh') },
          { value: 'first_year_premium', text: this.$t('products.medical.md_firstYearPremiumLowtoHigh') },
        ],
      },
    };
  },

  computed: {
    modalOpen() {
        return this.$store.getters['modal/showDisplayMobileFilter'].isOpen
      },
    mainQueryLoading() {
      return this.$apollo.queries.medicalPlanScenarios.loading;
    },

    resultMessage() {
      if (this.mainQueryLoading) {
        return this.$t('products.medical.md_result').replace('$num', '{ }');
      } else if (this.filter.selectionSelected == true) {
        return this.$t('products.medical.md_result').replace('$num', this.displayProducts.length);
      } else {
        return this.$t('products.medical.md_result').replace('$num', this.rows);
      }
    },

    displayProducts() {
      return this.filteredItem?.map((item) => ({
        id: item.scenario_code,
        category: this.category,
        scenarioId: item.scenarioID,
        showFiveStarBadge: this.$formatShowFiveStarBadge(item.overall_star),
        showTrending: false,
        productLink: this.$extendPath(
          this.$route.path,
          '/' +
            item.scenario_code +
            '?age=' +
            this.filter.ageValue.value +
            '&gender=' +
            this.filter.genderValue.value +
            (this.filter.vhisTypeValue.value === '44' || this.filter.vhisTypeValue.value === '45' ? '&isvhis=1' : '')
        ),
        productName: item.plan_name,
        insuranceCompany: {
          name: item.insurer_name_first + ' | ' + item.insurer_name_second,
          code: item.insurer_code,
          logoSrc: item.insurer_logo?.data?.attributes.url,
          logoAlt: item.insurer_name_first,
        },
        userRating: {
          score: item.overall_star,
          numberOfRatedUser: '0',
        },
        tenlifeScore: {
          score: parseFloat(this.getScore(item)),
          description: this.$t('products.medical.md_overall_score'),
          toolTipHtml: this.getTooltipContentByKey('md_overall_score'),
        },
        features: [
          {
            text: item.room,
            type: 'room_type',
          },
          {
            text: item.geo_region,
            type: 'geographical_coverage',
          },
          {
            text: item.vhis_type,
            type: 'plan_type',
          },
          {
            text: this.$formatPrice(item.deductible) + ' ' + this.$t('products.medical.md_deductible'),
            type: 'deductible',
          },
        ],
        keyItems: [
          {
            value: this.$formatScore(item.medical_coverage_score) + ' / 10',
            key: this.$t('products.medical.md_medicalCoverageScore'),
            topSubText: '',
            toolTipHtml: this.getTooltipContentByKey('md_medicalCoverageScore'),
            symbolValue: '',
            originalValue: '',
          },
          {
            value: this.$formatScore(item.special_feature_score) + ' / 10',
            key: this.$t('products.medical.md_special_feature_score'),
            topSubText: '',
            toolTipHtml: this.getTooltipContentByKey('md_special_feature_score'),
            symbolValue: '',
            originalValue: '',
          },
          {
            value: item.discounted_ten_year_avg_premium
              ? item.discounted_ten_year_avg_premium.toLocaleString('en-US')
              : parseInt(item.average_premium.toFixed(0)).toLocaleString('en-US'),
            key: this.$t('products.medical.md_10_yearAvgPremium'),
            topSubText: item.currency,
            toolTipHtml: this.get10YearAveragePremiumTooltip(),
            symbolValue: '',
            originalValue: item.discounted_ten_year_avg_premium
              ? parseInt(item.average_premium.toFixed(0)).toLocaleString('en-US')
              : '',
          },
        ],
        compactKeyItems: [
          {
            value: this.$formatScore(item.medical_coverage_score) + ' / 10',
            key: this.$t('products.medical.md_medicalCoverageScore'),
            topSubText: '',
            toolTipHtml: this.getTooltipContentByKey('md_medicalCoverageScore'),
            symbolValue: '',
            originalValue: '',
          },
          {
            value: this.$formatScore(item.special_feature_score) + ' / 10',
            key: this.$t('products.medical.md_special_feature_score'),
            topSubText: '',
            toolTipHtml: this.getTooltipContentByKey('md_special_feature_score'),
            symbolValue: '',
            originalValue: '',
          },
          {
            value: item.discounted_ten_year_avg_premium
              ? item.discounted_ten_year_avg_premium.toLocaleString('en-US')
              : parseInt(item.average_premium.toFixed(0)).toLocaleString('en-US'),
            key: this.$t('products.medical.md_10_yearAvgPremium'),
            topSubText: item.currency,
            toolTipHtml: this.get10YearAveragePremiumTooltip(),
            symbolValue: '',
            originalValue: item.discounted_ten_year_avg_premium
              ? parseInt(item.average_premium.toFixed(0)).toLocaleString('en-US')
              : '',
            bottomSubText: `/${this.$t('products.yearUnit')}`,
            isTextBlack: false,
            isTextBold: true
          },
        ],
        mobileKeyItems: [
          {
            value: this.$formatScore(item.medical_coverage_score) + ' / 10',
            key: this.$t('products.medical.md_medicalCoverageScore'),
            topSubText: '',
            toolTipHtml: this.getTooltipContentByKey('md_medicalCoverageScore'),
            symbolValue: '',
            originalValue: '',
          },
          {
            value: this.$formatScore(item.special_feature_score) + ' / 10',
            key: this.$t('products.medical.md_special_feature_score'),
            topSubText: '',
            toolTipHtml: this.getTooltipContentByKey('md_special_feature_score'),
            symbolValue: '',
            originalValue: '',
          },
          {
            value: item.discounted_ten_year_avg_premium
              ? item.discounted_ten_year_avg_premium.toLocaleString('en-US')
              : parseInt(item.average_premium.toFixed(0)).toLocaleString('en-US'),
            key: this.$t('products.medical.md_10_yearAvgPremium'),
            topSubText: item.currency,
            toolTipHtml: this.get10YearAveragePremiumTooltip(),
            symbolValue: '',
            originalValue: item.discounted_ten_year_avg_premium
              ? parseInt(item.average_premium.toFixed(0)).toLocaleString('en-US')
              : '',
            bottomSubText: `/${this.$t('products.yearUnit')}`,
            isTextBlack: false,
            isTextBold: true
          },
        ],
        promotion: {
          category:
            item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionCategory,
          title:
            item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionTitle,
          ctaButtonLink:
            item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonLink,
          ctaButtonText:
            item.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonText,
          promotionId: item.product_promotion?.id,
          scenarioId: item.scenarioID,
          lastCall: item.promotion_last_call
        },
        mainButtonCTA: item.main_cta,
        showShortcut: item.shortcut,
        price: {
          originalPrice: item.promotion_prices[0] ? parseInt(item.fyp.toFixed(0)).toLocaleString('en-US') : '',
          discountPrice: item.promotion_prices[0]
            ? parseInt(item.promotion_prices[0]).toLocaleString('en-US')
            : parseInt(item.fyp.toFixed(0)).toLocaleString('en-US'),
          prefix: item.currency,
          postfix: '',
          subText: this.$t('products.medical.md_firstYearPremium'),
          toolTipHtml: this.getFirstYearPremiumTooltip(),
        },
      }));
    },
    filteredItem() {
      let productList = [];

      if(this.filteredProductListOfAvgPremiumAndFirstPremiumDiscount) {
        if(this.filter.selectionSelected == true) {
          productList = this.filteredProductListOfAvgPremiumAndFirstPremiumDiscount.filter((item) => item.apply_online_insurer == true)
        } else {
          productList = this.filteredProductListOfAvgPremiumAndFirstPremiumDiscount
        }
        return productList
      } else {
        return null;
      }
    },
    rows() {
      if (this.filteredProductListOfAvgPremiumAndFirstPremiumDiscount) {
        return this.filteredProductListOfAvgPremiumAndFirstPremiumDiscount.length;
      }
      return null;
    },
    filteredProductListOfAvgPremiumAndFirstPremiumDiscount() {
      if (this.sortedItem !== null) {
        const filteredList = this.sortedItem.filter((product) => {
          const avgPremium = product.discounted_ten_year_avg_premium? product.discounted_ten_year_avg_premium : product.average_premium;
          const firstYearPremium = product.promotion_prices.length >=1? product.promotion_prices[0]: product.fyp;

          if (this.filter.avgAnnualPremiumValue.value[1] == 50000 && this.filter.firstPremiumValue.value[1] == 50000) {
            return avgPremium >= this.filter.avgAnnualPremiumValue.value[0]
              && firstYearPremium >= this.filter.firstPremiumValue.value[0];
          }
          if (this.filter.avgAnnualPremiumValue.value[1] == 50000 && this.filter.firstPremiumValue.value[1] < 50000) {
            return avgPremium >= this.filter.avgAnnualPremiumValue.value[0]
              && firstYearPremium <= this.filter.firstPremiumValue.value[1] && firstYearPremium >= this.filter.firstPremiumValue.value[0];
          }
          if (this.filter.avgAnnualPremiumValue.value[1] < 50000 && this.filter.firstPremiumValue.value[1] == 50000) {
            return avgPremium <= this.filter.avgAnnualPremiumValue.value[1] && avgPremium >= this.filter.avgAnnualPremiumValue.value[0]
              && firstYearPremium >= this.filter.firstPremiumValue.value[0];
          }
          // if (this.filter.firstPremiumValue.value[1] == 50000) {
          //   return avgPremium >= this.filter.avgAnnualPremiumValue.value[0]
          //     && firstYearPremium >= this.filter.firstPremiumValue.value[0];
          // }
          return avgPremium <= this.filter.avgAnnualPremiumValue.value[1] && avgPremium >= this.filter.avgAnnualPremiumValue.value[0]
                && firstYearPremium <= this.filter.firstPremiumValue.value[1] && firstYearPremium >= this.filter.firstPremiumValue.value[0];
        })
        return filteredList;
      } else {
        return null;
      }
    },
    sortedItem() {
      if (this.sortingData.sortValue.value === 'five_star') {
        if (this.simpleItems) {
          return this.simpleItems
            .map((item) => item)
            .sort((a, b) => {
              const aAveragePrem = a.discounted_ten_year_avg_premium
                ? a.discounted_ten_year_avg_premium
                : a.average_premium;
              const bAveragePrem = b.discounted_ten_year_avg_premium
                ? b.discounted_ten_year_avg_premium
                : b.average_premium;
              const aFyp = a.promotion_prices[0] ? a.promotion_prices[0] : a.fyp;
              const bFyp = b.promotion_prices[0] ? b.promotion_prices[0] : b.fyp;
              return (
                Number(this.$formatShowFiveStarBadge(b.overall_star)) - Number(this.$formatShowFiveStarBadge(a.overall_star)) ||
                this.getScore(b) - this.getScore(a) ||
                this.getMedicalCoverageScore(b) - this.getMedicalCoverageScore(a) ||
                b.special_feature_score - a.special_feature_score ||
                aAveragePrem - bAveragePrem ||
                aFyp - bFyp
              );
            });
        }
      }  else if (this.sortingData.sortValue.value === 'overall_score') {
        if (this.simpleItems) {
          return this.simpleItems
            .map((item) => item)
            .sort((a, b) => {
              const aAveragePrem = a.discounted_ten_year_avg_premium
                ? a.discounted_ten_year_avg_premium
                : a.average_premium;
              const bAveragePrem = b.discounted_ten_year_avg_premium
                ? b.discounted_ten_year_avg_premium
                : b.average_premium;
              const aFyp = a.promotion_prices[0] ? a.promotion_prices[0] : a.fyp;
              const bFyp = b.promotion_prices[0] ? b.promotion_prices[0] : b.fyp;
              return (
                this.getScore(b) - this.getScore(a) ||
                Number(this.$formatShowFiveStarBadge(b.overall_star)) - Number(this.$formatShowFiveStarBadge(a.overall_star)) ||
                this.getMedicalCoverageScore(b) - this.getMedicalCoverageScore(a) ||
                b.special_feature_score - a.special_feature_score ||
                aAveragePrem - bAveragePrem ||
                aFyp - bFyp
              );
            });
        }
      }
      else if (this.sortingData.sortValue.value === 'medical_coverage_score') {
        if (this.simpleItems) {
          return this.simpleItems
            .map((item) => item)
            .sort((a, b) => {
              const aAveragePrem = a.discounted_ten_year_avg_premium
                ? a.discounted_ten_year_avg_premium
                : a.average_premium;
              const bAveragePrem = b.discounted_ten_year_avg_premium
                ? b.discounted_ten_year_avg_premium
                : b.average_premium;
              const aFyp = a.promotion_prices[0] ? a.promotion_prices[0] : a.fyp;
              const bFyp = b.promotion_prices[0] ? b.promotion_prices[0] : b.fyp;
              return (
                this.getMedicalCoverageScore(b) - this.getMedicalCoverageScore(a) ||
                Number(this.$formatShowFiveStarBadge(b.overall_star)) - Number(this.$formatShowFiveStarBadge(a.overall_star)) ||
                this.getScore(b) - this.getScore(a) ||
                b.special_feature_score - a.special_feature_score ||
                aAveragePrem - bAveragePrem ||
                aFyp - bFyp
              );
            });
        }
      } else if (this.sortingData.sortValue.value === 'special_feature_score') {
        if (this.simpleItems) {
          return this.simpleItems
            .map((item) => item)
            .sort((a, b) => {
              const aAveragePrem = a.discounted_ten_year_avg_premium
                ? a.discounted_ten_year_avg_premium
                : a.average_premium;
              const bAveragePrem = b.discounted_ten_year_avg_premium
                ? b.discounted_ten_year_avg_premium
                : b.average_premium;
              const aFyp = a.promotion_prices[0] ? a.promotion_prices[0] : a.fyp;
              const bFyp = b.promotion_prices[0] ? b.promotion_prices[0] : b.fyp;
              return (
                b.special_feature_score - a.special_feature_score ||
                Number(this.$formatShowFiveStarBadge(b.overall_star)) - Number(this.$formatShowFiveStarBadge(a.overall_star)) ||
                this.getScore(b) - this.getScore(a) ||
                this.getMedicalCoverageScore(b) - this.getMedicalCoverageScore(a) ||
                aAveragePrem - bAveragePrem ||
                aFyp - bFyp
              );
            });
          }
      } else if (this.sortingData.sortValue.value === 'average_premium') {
        if (this.simpleItems) {
          return this.simpleItems
            .map((item) => item)
            .sort((a, b) => {
              const aAveragePrem = a.discounted_ten_year_avg_premium
                ? a.discounted_ten_year_avg_premium
                : a.average_premium;
              const bAveragePrem = b.discounted_ten_year_avg_premium
                ? b.discounted_ten_year_avg_premium
                : b.average_premium;
              const aFyp = a.promotion_prices[0] ? a.promotion_prices[0] : a.fyp;
              const bFyp = b.promotion_prices[0] ? b.promotion_prices[0] : b.fyp;
              return (
                aAveragePrem - bAveragePrem ||
                Number(this.$formatShowFiveStarBadge(b.overall_star)) - Number(this.$formatShowFiveStarBadge(a.overall_star)) ||
                this.getScore(b) - this.getScore(a) ||
                this.getMedicalCoverageScore(b) - this.getMedicalCoverageScore(a) ||
                b.special_feature_score - a.special_feature_score ||
                aFyp - bFyp
              );
            });
        }
      } else if (this.sortingData.sortValue.value === 'first_year_premium') {
        if (this.simpleItems) {
          return this.simpleItems
          .map((item) => item)
          .sort((a, b) => {
            const aAveragePrem = a.discounted_ten_year_avg_premium
              ? a.discounted_ten_year_avg_premium
              : a.average_premium;
            const bAveragePrem = b.discounted_ten_year_avg_premium
              ? b.discounted_ten_year_avg_premium
              : b.average_premium;
            const aFyp = a.promotion_prices[0] ? a.promotion_prices[0] : a.fyp;
            const bFyp = b.promotion_prices[0] ? b.promotion_prices[0] : b.fyp;
            return (
              aFyp - bFyp ||
              aAveragePrem - bAveragePrem ||
              Number(this.$formatShowFiveStarBadge(b.overall_star)) - Number(this.$formatShowFiveStarBadge(a.overall_star)) ||
              this.getScore(b) - this.getScore(a) ||
              this.getMedicalCoverageScore(b) - this.getMedicalCoverageScore(a) ||
              b.special_feature_score - a.special_feature_score
            );
          })
        }
      }

      return null;
    },
    simpleItems() {
      if (this.medicalPlanScenarios && !this.$apollo.queries.medicalPlanScenarios.loading) {
        return this.medicalPlanScenarios.data.map((item) => {
          let promotionPrices = Array;
          promotionPrices = [];

          let discountedTenYearAvgPremium = null;
          const discountedFirstYearPremium = null;
          const age = parseInt(this.filter.ageValue?.value);
          let promotions = null;
          let promotion = null;
          let promotionLastCall = null;
          let ApplyOnlineInsurer = false;
          const planName =
            item.attributes.medical_plan.data.attributes.medical_plan_translations.data[0].attributes.name;
          let decoderCTALink = '';
          // let decoderCTAText = '';

          let mainCTA = this.getDecoderCTA(item, decoderCTALink);

          const shortcut = this.getProductShortcut(item.attributes);

          // check scenario level promo first , then plan level promotion
          if (item.attributes.product_promotions.data?.length > 0) {
            promotions = item.attributes.product_promotions.data;
          }
          if (item.attributes.medical_plan.data.attributes.product_promotions.data?.length > 0) {
            promotions = item.attributes.medical_plan.data.attributes.product_promotions.data;
          }

          if(promotions != null) {
            promotion = this.checkPromotionValid(promotions);
            if (!promotion) {
              promotion = null;
            } else {
              if (promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink) {
                decoderCTALink =
                  promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink;
                // decoderCTAText = this.$t('products.product_website');
              }
              if (promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.ApplyOnlineInsurer) {
                ApplyOnlineInsurer = promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.ApplyOnlineInsurer;
              }

              mainCTA = this.getDecoderCTA(item, decoderCTALink, promotion);

              promotionLastCall = this.checkPromotionLastCall(promotion);

              const discounts = promotion.attributes.DiscountPercentage;
              if (discounts) {
                // calculate promotion price and avg premium
                let tenYearPremium = 0;
                const firstYearPremium = 0;

                const premium = item.attributes.premium_details_in_ten_years;

                const premiumArray = this.getPremium(premium, age);

                premiumArray.forEach((premium) => {
                  const i = premium.age - age;
                  if (discounts['Year' + parseInt(i + 1)] === 0) {
                    promotionPrices[i] = null;
                    tenYearPremium += premium.value;
                  } else {
                    const calculatedPrice = (premium.value * (100 - discounts['Year' + parseInt(i + 1)])) / 100;
                    promotionPrices[i] = parseInt(calculatedPrice.toFixed(0));
                    tenYearPremium += calculatedPrice;
                  }
                });
                discountedTenYearAvgPremium = parseInt((tenYearPremium.toFixed(0) / premiumArray.length).toFixed(0));
              }
            }
          }

          // const fyp = item.attributes.medical_plan_premium_details.data.filter(agePremium =>{return agePremium.attributes.age === age})[0].attributes.fyp;
          // const averagePremium = item.attributes.medical_plan_premium_details.data.filter(agePremium => {return agePremium.attributes.age === age})[0].attributes.average_premium;
          const fyp = item.attributes.medical_plan_premium_details.data[0].attributes.fyp;
          const averagePremium = item.attributes.medical_plan_premium_details.data[0].attributes.average_premium;
          if (discountedTenYearAvgPremium === parseInt(averagePremium.toFixed(0))) {
            discountedTenYearAvgPremium = null;
          }

          const filteredTranslations = this.getFilteredTranslations(item.attributes.medical_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
          .insurance_company_translations.data[0].attributes.localizations.data);

          return {
            scenario_code: item.attributes.scenario_code,
            currency: item.attributes.medical_plan.data.attributes.currency.data.attributes.code,

            // // plan
            plan_code: item.attributes.medical_plan.data.attributes.plan_code,
            medical_coverage_score: item.attributes.medical_plan.data.attributes.medical_coverage_score,
            medical_coverage: item.attributes.medical_plan.data.attributes.medical_coverage,
            overall_score: item.attributes.medical_plan.data.attributes.overall_score,
            overall_star: item.attributes.medical_plan.data.attributes.overall_star,
            special_feature_score: item.attributes.medical_plan.data.attributes.special_feature_score,
            plan_name: planName,

            // feature
            room: item.attributes.medical_plan.data.attributes.medical_room.data.attributes.medical_room_translations
              .data[0].attributes.name,
            geo_region:
              item.attributes.medical_plan.data.attributes.medical_geo_region.data.attributes
                .medical_geo_region_translations.data[0].attributes.name,
            vhis_type:
              item.attributes.medical_plan.data.attributes.medical_vhis_type.data.attributes
                .medical_vhis_type_translations.data[0].attributes.name,
            deductible: item.attributes.medical_plan.data.attributes.deductible,

            additional_features: item.attributes.medical_plan.data.attributes.additional_features,
            // medical_inflation_protection: item.attributes.medical_plan.data.attributes.medical_inflation_protection,

            // // insurer
            insurer_name_first:
              item.attributes.medical_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                .insurance_company_translations.data[0].attributes.name,
            insurer_name_second:
              filteredTranslations[0].attributes.name,
            insurer_logo:
              item.attributes.medical_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                .logo,
            insurer_code:
              item.attributes.medical_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
                .code,
            scenarioID: item.id,

            // premium
            //  price: item.attributes.medical_plan_premium_details.data[0].attributes.price,
            fyp,
            average_premium: averagePremium,

            // premium
            product_promotion: promotion,
            promotion_prices: promotionPrices,
            promotion_last_call: promotionLastCall,
            discounted_ten_year_avg_premium: discountedTenYearAvgPremium,
            // discounted_first_year_premium: discountedFirstYearPremium,

            // decoder_cta_link: decoderCTALink,
            // decoder_cta_text: decoderCTAText,
            main_cta: mainCTA,
            // Apply Online Insurer
            apply_online_insurer: ApplyOnlineInsurer,
            shortcut: shortcut,
          };
        });
      }
      return null;
    },
    simpleRooms() {
      const rooms = [{ value: '65', text: this.$t('products.medical.md_roomTypeDefaultText') }];
      const tempRooms = this.medicalRooms?.data
        .map((item) => {
          return {
            value: item.id,
            text: item.attributes.medical_room_translations.data[0].attributes.name,
          };
        })
        .sort((a, b) => a.value - b.value);
      return tempRooms || rooms;
    },
    simpleGeoRegions() {
      const GeoRegions = [];
      const tmpRegion = this.medicalGeoRegions?.data.map((item) => {
        return {
          value: item.id,
          text: item.attributes.medical_geo_region_translations.data[0].attributes.name,
        };
      });

      return tmpRegion ? GeoRegions.concat(tmpRegion) : GeoRegions;
    },
    simpleVhisTypes() {
      const VhisTypes = [{ value: '-1', text: this.$t('products.any') }];
      const tmpVHis = this.medicalVhisTypes?.data.map((item) => {
        return {
          value: item.id,
          text: item.attributes.medical_vhis_type_translations.data[0].attributes.name,
        };
      });
      return tmpVHis ? VhisTypes.concat(tmpVHis) : VhisTypes;
    },
    slug() {
      if (this.filter.vhisTypeValue.value === '-1') {
        return 'medical';
      }
      if (this.filter.vhisTypeValue.value === '45') {
        return 'vhis'
      }
      return undefined;
    },
    selectedSortingLogic() {
      return this.sortingData.sortValue.value
    },
  },

  watch: {
    simpleRooms(newVal) {
      if (!newVal || newVal?.length <= 1) return;

      const filterValueToFix = {
        filterValuePath: 'filter.roomValue',
        filterOptionsPath: 'simpleRooms',
        queryKey: 'roomtype',
        defaultValue: '65',
      };
      this.fixFilterValue(filterValueToFix);
    },
    simpleGeoRegions(newVal) {
      if (!newVal || newVal?.length <= 1) return;

      // const filterValueToFix = {
      //   filterValuePath: 'filter.geoRegionValue',
      //   filterOptionsPath: 'simpleGeoRegions',
      //   queryKey: 'geo[]',
      //   defaultValue: [],
      //   type: 'array'
      // };
      const filterArrayValueToFixGeo = {
      filterValuePath: 'filter.geoRegionValue',
      filterOptionsPath: 'simpleGeoRegions',
      queryKey: 'geo[]',
    };
      // this.fixFilterValue(filterValueToFix);
      this.fixFilterArrayValueDueToQueryString(filterArrayValueToFixGeo);

    },

    simpleVhisTypes(newVal) {
      if (!newVal || newVal?.length <= 1) return;

      const filterValueToFix = {
        filterValuePath: 'filter.vhisTypeValue',
        filterOptionsPath: 'simpleVhisTypes',
        queryKey: 'vhistype',
        defaultValue: '-1',
      };
      this.fixFilterValue(filterValueToFix);
    },
  },

  created() {
    const filterValuesToWatch = [
      {
        filterValuePath: 'filter.genderValue',
        filterOptionsPath: 'filter.genderOptions',
        queryKey: 'gender',
        defaultValue: '1',
      },
      {
        filterValuePath: 'filter.ageValue',
        filterOptionsPath: 'filter.ageOptions',
        queryKey: 'age',
        defaultValue: '30',
      },
      {
        filterValuePath: 'filter.roomValue',
        filterOptionsPath: 'simpleRooms',
        queryKey: 'roomtype',
        defaultValue: '65',
        ignoreFix: true,
      },
      {
        filterValuePath: 'filter.geoRegionValue',
        filterOptionsPath: 'simpleGeoRegions',
        queryKey: 'geo[]',
        defaultValue: [{value: "86", text: this.$t('products.medical.md_default_geo_asia')}, {value: "87", text: this.$t('products.medical.md_default_geo_global_ex_us')}, {value: "88", text: this.$t('products.medical.md_default_geo_greater_china')}],
        ignoreFix: true,
        type: 'array',
      },
      {
        filterValuePath: 'filter.vhisTypeValue',
        filterOptionsPath: 'simpleVhisTypes',
        queryKey: 'vhistype',
        defaultValue: '-1',
        ignoreFix: true,
      },
      {
        filterValuePath: 'sortingData.sortValue',
        filterOptionsPath: 'sortingData.sortingOptions',
        queryKey: 'sort',
        defaultValue: 'five_star',
      },
      {
        filterValuePath: 'filter.insCompValue',
        filterOptionsPath: 'insuranceCompanies',
        queryKey: 'ins_comp[]',
        defaultValue: [],
        ignoreFix: true,
        type: 'array',
      },
      {
        filterValuePath: 'filter.deductibleValue.value[0]',
        queryKey: 'deductiblefrom',
        defaultValue: 15000,
        ignoreFix: true,
        type: 'slider',
      },
      {
        filterValuePath: 'filter.deductibleValue.value[1]',
        queryKey: 'deductibleto',
        defaultValue: 25000,
        ignoreFix: true,
        type: 'slider',
      },
      {
        filterValuePath: 'filter.avgAnnualPremiumValue.value[0]',
        queryKey: 'avgpremfrom',
        defaultValue: 0,
        ignoreFix: true,
        type: 'slider',
      },
      {
        filterValuePath: 'filter.avgAnnualPremiumValue.value[1]',
        queryKey: 'avgpremto',
        defaultValue: 50000,
        ignoreFix: true,
        type: 'slider',
      },
      {
        filterValuePath: 'filter.firstPremiumValue.value[0]',
        queryKey: 'firstpremfrom',
        defaultValue: 0,
        ignoreFix: true,
        type: 'slider',
      },
      {
        filterValuePath: 'filter.firstPremiumValue.value[1]',
        queryKey: 'firstpremto',
        defaultValue: 50000,
        ignoreFix: true,
        type: 'slider',
      },
      {
        filterValuePath: 'filter.selectionSelected',
        queryKey: 'applyOnlineInsurer',
        defaultValue: 'false',
        ignoreFix: true,
        type: 'checkbox',
      }
    ];

    this.createFilterWatchers(filterValuesToWatch);
    this.fixFilterValues(filterValuesToWatch);
  },

  mounted() {
    const filterArrayValueToFix = {
      filterValuePath: 'filter.insCompValue',
      filterOptionsPath: 'insuranceCompanies',
      queryKey: 'ins_comp[]',
    };
    // const filterArrayValueToFixGeo = {
    //   filterValuePath: 'filter.geoRegionValue',
    //   filterOptionsPath: 'simpleGeoRegions',
    //   queryKey: 'geo[]',
    // };
    this.fixFilterArrayValueDueToQueryString(filterArrayValueToFix);
    // this.fixFilterArrayValueDueToQueryString(filterArrayValueToFixGeo);
  },

  methods: {
    getDefaultRoom() {
      if (this.simpleRooms) {
        this.filter.roomValue.value = this.simpleRooms.filter((details) => {
          return details.code === 'SEMIPRIVATE';
        })[0].value;
      }
      return -1;
    },

    getScore(product) {
      return product.overall_score?.toFixed(1);
    },

    getMedicalCoverageScore(product) {
      return product.medical_coverage_score?.toFixed(1);
    },

    getPremium(premium, startAge) {
      const endAge = startAge + 9;
      const selectedAge = () => {
        return premium.data.filter((agePremium) => {
          return agePremium.attributes.age >= startAge && agePremium.attributes.age <= endAge;
        });
      };

      return selectedAge().map((agePremium) => ({
        age: agePremium.attributes.age,
        value: agePremium.attributes.price,
      }));
    },

    getTooltipContentByKey(mKey) {
      return this.medicalTooltips?.Medical?.ToolTips?.find(({ Key }) => Key === mKey)?.ToolTipContent ?? '';
    },

    getFirstYearPremiumTooltip() {
      const tooltip = this.getTooltipContentByKey('md_firstYearPremium');
      return tooltip
        .replace('{replace_age}', this.filter.ageValue?.text.toString())
        .replace('{replace_gender}', this.filter.genderValue?.text.toString());
    },

    get10YearAveragePremiumTooltip() {
      const tooltip = this.getTooltipContentByKey('md_10_yearAvgPremium');
      return tooltip
        .replace('{replace_gender}', this.filter.genderValue?.text.toString())
        .replace('{replace_age_from}', this.filter.ageValue?.value.toString())
        .replace('{replace_age_to}', (parseInt(this.filter.ageValue?.value) + 9).toString());
    },

    getDecoderCTA(item, promotionCTALink, promotion = null) {
      const planName = item.attributes.medical_plan.data.attributes.medical_plan_translations.data[0].attributes.name;
      const insurer = item.attributes.medical_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.insurance_company_translations.data[0].attributes.name;
      const decoderCTAWhatsappLink = this.$generateWhatsappCTALink(this.$t('products.medical.md_categoryName'), insurer, planName);
      const showCTA = item.attributes.show_cta;
      const saleable = item.attributes.medical_plan.data.attributes.saleable;
      const productWebsite = item.attributes.medical_plan.data.attributes.medical_plan_translations.data[0].attributes.product_website;
      const salesLink = process.env.SALES_EXTERNAL_URL + '/' + (this.currentLocale === 'en' ? 'en' : 'tc') + '/purchase?type=vhis&id=' + item.attributes.scenario_code + (promotion?.id ? '&promotionId=' + promotion?.id : '');

      if (!showCTA) return null;

      if (saleable) {
        return {
          text: this.$t('products.purchase_now'),
          link: salesLink,
          popupData: {
            applicationLink: salesLink,
            whatsappLink: decoderCTAWhatsappLink
          },
          type: 'popup'
        };
      } else if (promotionCTALink) {
        return {
          text: this.$t('products.product_website'),
          link: promotionCTALink,
        };
      } else if (productWebsite) {
        return {
          text: this.$t('products.product_website'),
          link: productWebsite,
          type: 'product-website',
        };
      } else {
        return {
          text: '',
          link: decoderCTAWhatsappLink,
        };
      }
    },
  },
  components: {
    QuickGuideWrapper
  }
};
